import { useDataChange, useDataValue } from 'Simple/Data'

let LEVELS = {
  div: 'Division',
  location: 'Location',
}

export function list(division, locations) {
  return [
    {
      id: division._id,
      text: `${division.name} (${LEVELS[division.level]})`,
    },
    ...locations.map(location => ({
      id: location._id,
      text: `${location.name}`,
    })),
  ]
}

export function useOnChange(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'selected',
  })

  let divisionId = useDataValue({
    viewPath: props.viewPath,
    path: 'division._id',
    context: 'organizations',
  })

  return function onChange(value) {
    change(next => {
      next.organization_id = value
      next.organization_level = divisionId === value ? 'div' : 'location'
      next.organization_locations = []
    })
  }
}
